/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { AppState } from "Dataflows/Reducers";
import {
  ISocialNetworkDataState,
  ISocialNetworkData,
  ISocialNetworkOptionList,
} from "../../Interfaces/SiteContent";

/**
 * Social Network data selector.
 */
export const getSocialNetworks = (state: ISocialNetworkDataState): ISocialNetworkData[] =>
  state.socialNetworks;

/**
 * Social Network option list data selector.
 */
export const getSocialNetworkOptionList = (
  state: ISocialNetworkDataState
): ISocialNetworkOptionList[] => state.socialNetworkOptionList;

export const getAppStateSocialNetworkOptionList = (state: AppState): ISocialNetworkOptionList[] =>
  state.socialNetworkDataState.socialNetworkOptionList;

/**
 * Social Network data load error selector.
 */
export const getSocialNetworkLoadError = (state: ISocialNetworkDataState): string =>
  state.socialNetworkLoadError;

export const getAppStateSocialNetworkLoadError = (state: AppState): string =>
  state.socialNetworkDataState.socialNetworkLoadError;
